//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import * as Permissions from '@services/permissions';

class PermissionsService {
  public hasPermissionForTask(task: string): boolean {
    return Permissions.hasPermissionForTask(task);
  }
}

// Exposes permissions variables that are initialized on page load to various angular components
angular.module('curalate').service('PermissionsService', [PermissionsService]);
